import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_FORCED_CANCELLATION } from 'src/helper/Permission'
import { eventBus } from 'src/helper/EventBus'
type Refresh = () => void

interface CancelItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingCancelItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirm: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpen: React.Dispatch<React.SetStateAction<boolean>> | undefined,
  setForcedCancel: React.Dispatch<React.SetStateAction<boolean>> | undefined,
}

export const cancelItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingCancelItem,
  setNameReserve,
  setHashItemReserve,
  setConfirm,
  setOpen,
  setForcedCancel
}: CancelItemReservationParams): Promise<void> => {
  try {
    setLoadingCancelItem(true)
    setOpen && setOpen(false)
    const response = await itemServices.cancel_item(hashItemReserve)
    if (response?.status === 'CANCELLED' ||response?.status === 'CANCELLATION_IN_PROGRESS' ||(response >= 200 && response <= 204)) {
      notify('ra.notification.canceled_item_reserve_success', {
        type: 'success',
        messageArgs: { reserve: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirm && setConfirm(false)
      setLoadingCancelItem(false)
      eventBus.emit('updateBillingStatus', hashItemReserve)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirm && setConfirm(false)
    setLoadingCancelItem(false)
    notify('ra.notification.canceled_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
  } catch (error) {
    notify('ra.notification.canceled_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
    setNameReserve('')
    setHashItemReserve('')
    setLoadingCancelItem(false)
    setConfirm && setConfirm(false)
    setOpen && setOpen(false)
    if (hasPermissionFunction('item', PERMISSION_FORCED_CANCELLATION)){
      setForcedCancel && setForcedCancel(true)
    }
  } finally {
    customAwait([refresh])
  }
}
